'use strict'

var Marionette = require('marionette')
var App = require('app')
var TabBehavior = require('src/behaviors/tabs')
var MapModule = require('src/common/map')
var _ = require('lodash')

var DialogComponent = require('src/components/dialog-view')

/**
 * Dialog body view
 * -----------------------------------------------------------------------------
 * Body of the dialog
 */
var DialogBody = DialogComponent.Body.extend({
  template: require('./templates/body.html'),
  events: {
    'change .js-preset-select': 'onPresetChange',
    'click .js-enable-group-edit': 'onEnableGroupEdit',
    'click .js-update-firmware': 'onUpdateFirmware',
    'click .js-control-button': 'onControlButton'
  },

  onControlButton: function(ev) {
    let command = ev.currentTarget.getAttribute('data-command');
    let value = ev.currentTarget.getAttribute('data-value');

    this.triggerMethod('control:send-command', {
      command: command,
      value: value
    })
  },
  /**
   * Handles the updating of all the necessary fields when a preset
   * is applied
   */
  populatePresetFields: function (values) {
    var self = this
    _.forEach(values, function (fieldValue, fieldName) {
      var splittedFieldName = fieldName.split('.')

      if (splittedFieldName.length <= 0) return false

      // generate the fieldname for querying
      var inputName = ''
      inputName = splittedFieldName[0]
      for (var i = 1; i < splittedFieldName.length; i++) {
        inputName += '[' + splittedFieldName[i] + ']'
      }

      // find the fields
      var element = self.el.querySelector('input[name="' + inputName + '"]')
      if (!element) return false

      // populate the fields
      switch (element.type) {
        case 'checkbox':
          element.checked = fieldValue

          break
        case 'text':
          element.value = fieldValue
          break
      }
    })
  },
  onUpdateFirmware: function(ev) {
    console.log('oeh')
  },
  onPresetChange: function (ev) {
    this.triggerMethod('dialog:load-preset', this, ev.currentTarget.value)
  },
  onDomRefresh: function () {

    var self = this

    if (!this.options.model) return
    if (this.options.model.isNew()) return
        
    setTimeout(function () {
      // location
      var loc = (self.model.attributes.geoLocation && self.model.attributes.geoLocation.length ) ?  _.values(self.model.attributes.geoLocation) : [0, 0];

      // map
      var editMap = new MapModule({
        'container': 'editMap',
        'location': loc,
        'zoomLevel': 20,
        'styleToggle': true
        
      })

      var feature = {
        'properties': {
          'name': self.model.get('name'),
          'id': self.model.get('_id'),
          'type': self.model.get('type'),
          'online': self.model.get('online'),
          'error': self.model.get('error'),
          'model': self.model
        }}

      editMap.addMarker(loc, {
        mapBoxOptions: {
          draggable: true
        },
        onDragEnd: function (event) {
          var marker = event.target // you could also simply access the marker through the closure
          var result = marker.getLatLng() // but using the passed event is cleaner
          //self.model.setLocation(result.lat, result.lng)
          self.el.querySelector('.js-geo-lat').value = result.lat;
          self.el.querySelector('.js-geo-lng').value = result.lng;
          
        },
        feature: feature
      })
    }, 0)
  },
  templateContext: function () {
    var self = this
    return {
      isNew: function() {
        if (!self.options.model) return false;
        return self.options.model.isNew()
      },
      getPresetList: function () {
        var deviceType = self.options.deviceType
        if (!self.options.client) return false
        var clientPresets = self.options.client.get('presets')
        if (!clientPresets) return false
        return _.filter(clientPresets, function (o) { return o.deviceType === deviceType && o.type === 'edit' })
      },
      isGroupEdit: function () {
        if (!self.options.model) {
          return true
        } else {
          return false
        }
      },
      isDeviceType: function(type) {
        return (self.options.deviceType === type)
      },
      hasDeviceType: function () {
        return (self.options.deviceType)
      },
      getClientId: function () {
        if (!self.options.client) return false;
        return self.options.client.get('_id')
      },
      getClients: App.TemplateHelpers.getClients,
      userHasRole: App.TemplateHelpers.userHasRole,
      getDeviceTypes: App.TemplateHelpers.getDeviceTypes,
      getPropertyFieldName: App.TemplateHelpers.getPropertyFieldName,
      getPropertyAttribute: App.TemplateHelpers.getPropertyAttribute,
      getSensorFieldName: App.TemplateHelpers.getSensorFieldName,
      getSensorAttribute: App.TemplateHelpers.getSensorAttribute,
      hasSensor: App.TemplateHelpers.hasSensor,
      hasProperty: App.TemplateHelpers.hasProperty,
      getConditionalStr: App.TemplateHelpers.getConditionalStr,
      getSensorValue: App.TemplateHelpers.getSensorValue,
      getDeviceTypeLabel: App.TemplateHelpers.getDeviceTypeLabel,
      getAttribute: App.TemplateHelpers.getAttribute
    }
  }
})

/**
 * Dialog view
 * -----------------------------------------------------------------------------
 * The dialog view
 */
var DialogView = DialogComponent.Layout.extend({
  className: 'dialog dialog-device-edit',
  childViewTriggers: {
    'dialog:load-preset': 'dialog:load-preset'
  },
  modelEvents: {
    'change': false
  },
  onRender: function () {
    var bodyView = new DialogBody(this.options)
    this.showChildView('bodyRegion', bodyView)
  }
})

module.exports.Layout = DialogView



// WEBPACK FOOTER //
// ./js/modules/devices/edit/view.js